$(document).ready(function(){
var $anchors = $('.shop_index'),
        $zone_div = $('#the_zone'),
        $body = $('#shop_menu ul');

    function change_bg() {
        var $win = $(window),
            $the_zone = $win.height() / 50;

        $zone_div.width($win.width()).height($the_zone);

        $anchors.each(function() {
            var anchor_pos = $(this).get( 0 ).offsetTop;
                zone_pos = $zone_div.position().top + $the_zone;

            if (anchor_pos < zone_pos) {
                $body.removeClass().addClass(this.id);
            }

        });
    }
    change_bg();
    $(window).scroll(change_bg);




  

$(function() {
$(".sub_grand_menu_top").click(function(){
$(".sub_grand_menu_top .button-navi-icon").addClass("close");
$(".button-close").css('z-index', '9999');
$("#menu_index").fadeIn();
$('#sp_header').removeClass("active");
});
});





$(function() {
$(".button-close").click(function(){
$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
$(".button-close").css('z-index', '-9999');
$("#menu_index").fadeOut();
$('#sp_header').addClass("active");
});
});




$(function() {
$(".menus a").click(function(){
$(".button-navi-icon").removeClass("close");
$("#menu_index").fadeOut();
$("#about_page").fadeIn();
$(".button-close").css('z-index', '-9999');
$('#sp_header').addClass("active");
});
});




  
        $(function() {
          $(".sub_grand_menu_top").click(function(){
                $(".memu_sec01").addClass("active");
						$("#menu_back").fadeIn(400);
						 
          });
		});
		

		
		

     $(function() {
          $(".button-close").click(function(){
                $(".memu_sec02").fadeOut();
                $("#menu_back").fadeOut();
                 $(".memu_sec01").removeClass("active");
          });
      });

  
    
    

      $(function() {
          $(".t_sub_m02").click(function(){
                $(".memu_sec02").fadeIn();
                
                 $(".sub_m02").fadeIn();
                 $(".sub_m02").addClass("active");
                $(".sub_m02").css('z-index', '999');
                
              $(".sub_m01, .sub_m03").removeClass("active");
              $(".sub_m01, .sub_m03").fadeOut();
              
          });
      });
      

    

      $(function() {
          $(".t_sub_m03").click(function(){
                $(".memu_sec02").fadeIn();
                
                 $(".sub_m03").fadeIn();
                 $(".sub_m03").addClass("active");
                $(".sub_m03").css('z-index', '999');
                
                $(".sub_m01, .sub_m02").removeClass("active");
                $(".sub_m01,.sub_m02").fadeOut();
              
          });
      });
      

    
    

      $(function() {
          $(".sub_close").click(function(){
                $(".memu_sec02").fadeOut();
          });
      });
      

        $(function() {
          $(".footer_newsletter .not").click(function(){
						$(".bottom-newsletter").fadeIn();
						 
          });
		});

  


$(function() {
$(".quick-search__trigger").click(function(){
$("#head_logo").css('z-index', '99');
});
});

  $(function() {
$(".search__overlay, .search__input-actions").click(function(){
$("#head_logo").css('z-index', '999');
});
});

  



$(window).on('scroll',function(){
var winPosTop = $(window).scrollTop();
if(winPosTop >= 700){
$('body.st_page').addClass("active");
} else if(winPosTop < 400){
$('body.st_page').removeClass("active");
}
});





$('.footer_backto a, .top_menu_bottom a, .menu_scroll_menu a').click(function(){
var target = $(this.hash);
//$(this).text(target.length+"/");
if (target) {
var targetOffset = target.offset().top;
$('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
return false;}
});



$('.menus a, .top_scroll a').click(function(){
var target = $(this.hash);
//$(this).text(target.length+"/");
if (target) {
var targetOffset = target.offset().top;
$('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
return false;}
});
		
		
		$('.detail_top_list a').click(function(){
var target = $(this.hash);
//$(this).text(target.length+"/");
if (target) {
var targetOffset = target.offset().top -120;
$('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
return false;}
});
		
  

$(window).on('scroll',function(){
var winPosTop = $(window).scrollTop();
if(winPosTop >= 200){
$('#home').addClass("active");
} else if(winPosTop < 200){
$('body').removeClass("active");
}
});
		
		
		


});
















